module.exports = __webpack_public_path__ + "static/media/poster2.6444a93f.png";